import axios from "axios";
import { commonApi } from "../common/constants"; 

export async function submitContactRequest(requestData) {
    const apiUrl = `${commonApi}requests/add_request`; 
    console.log("Api Url: ", apiUrl);

    const payload = {
        requestDate: new Date().toISOString(), 
        name: requestData.name,
        phone: requestData.phone, 
        email: requestData.email,
        requestedBy: requestData.requestedBy, 
        message: requestData.message
    };

    try {
        const response = await axios.post(apiUrl, payload);
        console.log("Response: ", response.data);
        
        return { 
            success: true, 
            message: "Request submitted successfully!", 
            data: response.data 
        };
    } catch (error) {
        console.error("Network/API error:", error);
        return { 
            success: false, 
            message: error.response?.data?.message || error.message || "Network error", 
            data: null 
        };
    }
}